import React, { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import { Button } from 'loyal-react'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'
import { getButton } from 'Shared/GTM/getButton'

const IuppHeaderDisconnected = ({ profile }) => {
  const redirectLoginPage = () => {
    window.location.href = process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP
  }

  return (
    <Fragment>
      <div className='placeholder-header' />
      <header className='iupp-header header-disconnected'>
        <MediaQuery minDeviceWidth={1025}>
          <nav arial-label='Segmento' className='menu menu-segmentation'>
            <div className='container'>
              <div className='flexible-items-container' role='menubar'>
                <a
                  onClick={() => {
                    getButton(false, 'home', 'clique:botao', 'para-seu-negocio', 'meu-negocio')
                  }}
                  href='#'
                  className='flex-item mn-item mn-personal'
                  title='Ver as vantages exclusivas para o seu negócios'
                  role='menuitem'
                >
                  para o seu negócio
                </a>
                <a
                  href='/'
                  className='flex-item mn-item'
                  title='Ver as vantagens exclusivas para você'
                  role='menuitem'
                  onClick={() => {
                    getButton(false, 'home', 'clique:botao', 'para-voce', 'meu-negocio')
                  }}
                >
                  para você
                </a>
              </div>
            </div>
          </nav>
        </MediaQuery>
        <nav arial-label='Menu' className='meu-bairro-head menu menu-navigation '>
          <div className='container'>
            <div className='title-meu-bairro'>
              <a href='/meu-negocio' title='Ir para a página inicial' className='logo-header-community'>
                comunidade <br />
                iupp
              </a>
            </div>
            <div className='flexible-items-container' role='menu'>
              <div className='menu-itens'>
                <NavLink
                  to='/meu-negocio/#benefits'
                  data-target='#benefits'
                  className='flex-item mn-item mn-benefits'
                  title='benefícios que vão te ajudar a vender mais.'
                  role='menuitem'
                  onClick={() => {
                    getButton(false, 'home', 'clique:menu', 'beneficios', 'meu-negocio')
                  }}
                >
                  benefícios
                </NavLink>
              </div>
              <div className='menu-itens'>
                <NavLink
                  to='/meu-negocio/#help'
                  data-target='#help'
                  className='flex-item mn-item mn-help'
                  title='está com dúvidas? veja nossas perguntas frequentes.'
                  role='menuitem'
                  onClick={() => {
                    getButton(false, 'home', 'clique:menu', 'ajuda', 'meu-negocio')
                  }}
                >
                  ajuda
                </NavLink>
              </div>
              <a
                href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN}
                className='flex-item mn-item mn-login'
                title='Ir para área de login'
                role='menuitem'
                onClick={() => {
                  getButton(false, 'home', 'clique:botao', 'entrar', 'meu-negocio')
                }}
              >
                entrar
              </a>
              <Button
                onClick={() => {
                  redirectLoginPage()
                  getButton(false, 'home', 'clique:botao', 'cadastre-se', 'meu-negocio')
                }}
                text='cadastre-se'
                title='Fazer cadastro'
                className='flex-item mn-item mn-register'
                tabIndex={0}
              />
            </div>
          </div>
        </nav>
        <MediaQuery maxDeviceWidth={1024}>
          <nav arial-label='Segmento' className='menu menu-segmentation'>
            <div className='container'>
              <div className='flexible-items-container' role='menubar'>
                <a
                  href='/'
                  className='flex-item mn-item'
                  title='Ver as vantagens exclusivas para você'
                  role='menuitem'
                  onClick={() => {
                    getButton(false, 'home', 'clique:botao', 'para-voce', 'meu-negocio')
                  }}
                >
                  para você
                </a>
                <a
                  href='#'
                  className='flex-item mn-item mn-personal'
                  title='Ver as vantages exclusivas para o seu negócios'
                  role='menuitem'
                  onClick={() => {
                    getButton(false, 'home', 'clique:botao', 'para-seu-negocio', 'meu-negocio')
                  }}
                >
                  para o seu negócio
                </a>
              </div>
            </div>
          </nav>
        </MediaQuery>
      </header>
    </Fragment>
  )
}

IuppHeaderDisconnected.propTypes = {
  profile: PropTypes.object
}

export default IuppHeaderDisconnected



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/Header/index.js